export default "__VITE_ASSET__BqKo1bsj__"